import {FontVariants} from '@contentlab/types/captions';

// Font metadata (also used as API response)
export interface FontMetadata {
  id: string;
  name: string;
  downloadUrls: Record<FontVariants, string>;
}

// Font loading status
export enum FontLoadingStatus {
  NOT_LOADED = 'not_loaded',
  LOADING = 'loading',
  LOADED = 'loaded',
  ERROR = 'error',
}

// Font loading result
export interface FontLoadingResult {
  status: FontLoadingStatus;
  error?: string;
}
